import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { toZonedTime } from 'date-fns-tz';
import { environment } from '../../environments/environment';

export const endLotteryGuard: CanActivateFn = () => {
  const router = inject(Router);
  const currentDate = new Date();
  const timeZone = 'Europe/Warsaw';
  const zoneDate = toZonedTime(currentDate, timeZone);
  const cutoffDate = environment.endLotteryDate;
  if (isPlatformServer(inject(PLATFORM_ID))) {
    return of(true);
  }
  if (zoneDate >= cutoffDate) {
    router.navigate([`/`]);
    return of(false);
  }
  return of(true);
};
